import React, { useMemo, useState } from "react";
import {
  AppBar, Toolbar, Typography, Paper, Grid, TextField, Button, Checkbox,
  FormControlLabel, FormControl, InputLabel, Select, MenuItem, InputAdornment,
  IconButton, Chip, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TablePagination, Tooltip, CircularProgress, Divider
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import SearchIcon from "@material-ui/icons/Search";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import ReceiptLongOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import TrendingUpOutlinedIcon from "@material-ui/icons/TrendingUpOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import "./AccountMovement.css";
import AccountMovementTable from "./AccountMovementTable";
import { docTypes, SAdefaultValues } from "../AccountingRPT/accountingRPT-services";
import AccountSelect from "../../../../components/controls/accounts-select";
import { exportExcelReport } from "../../../../components/ExcelExport";
import moment from "moment";
import { GetItemFromOptions } from "../../../../services/global-services";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { sto } from "../../../../Context/InshData";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BarChartOutlined, ViewListOutlined } from "@material-ui/icons";
const useStyles = makeStyles(() => ({
  root: { width: "100%", minHeight: "100vh", background: "#f4f6f8", direction: "ltr", color: "#283746" },
  appBar: { background: "linear-gradient(105deg,#f7f8fa 0%,#e9edf1 100%)", color: "#34495e", boxShadow: "0 2px 10px rgba(39,55,72,.08)", borderBottom: "1px solid #dfe4e9" },
  toolbar: { minHeight: 58, display: "flex", justifyContent: "space-between", gap: 16 },
  title: { fontWeight: 800, fontSize: 20, color: "#34495e" },
  filters: { padding: 15, borderRadius: 13, border: "1px solid #e0e5e9", boxShadow: "0 4px 14px rgba(39,55,72,.055)" },
  field: { background: "#fff", borderRadius: 8 },
  button: { borderRadius: 8, fontWeight: 700, textTransform: "none", padding: "8px 14px", fontSize: 12 },
  primary: { color: "#fff", background: "linear-gradient(110deg,#667788,#526273)", "&:hover": { background: "#435466" } },
  tablePaper: { borderRadius: 13, overflow: "hidden", border: "1px solid #e0e5e9", boxShadow: "0 4px 14px rgba(39,55,72,.055)" },
  headCell: { background: "#5d6268", color: "#fff", fontWeight: 800, whiteSpace: "nowrap", fontSize: 12, padding: "11px 10px" },
  bodyCell: { fontSize: 12, whiteSpace: "nowrap", padding: "8px 10px", color: "#34495e", borderBottom: "1px solid #e9edf1" },
  row: { "&:nth-of-type(even)": { background: "#f7f8fa" }, "&:hover": { background: "#edf2f6" } },
  smallButton: { minWidth: 0, borderRadius: 7, padding: "4px 8px", marginLeft: 5, fontSize: 11, fontWeight: 700, textTransform: "none" }
}));



const money = (value) => Number(value || 0).toLocaleString("en-US", {
  minimumFractionDigits: 2, maximumFractionDigits: 2
});

function SelectField({ label, value, onChange, options, className }) {
  return (
    <FormControl variant="outlined" size="small" className={`am-field ${className || ""}`}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {options.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
      </Select>
    </FormControl>
  );
}

function SummaryCard({ title, value, icon, tone }) {
  return (
    <Paper elevation={0} className={`am-summary-card ${tone}`}>
      <div className="am-summary-icon">{icon}</div>
      <div className="am-summary-copy">
        <Typography className="am-summary-title">{title}</Typography>
        <Typography className="am-summary-value">{value} <small>ر.س</small></Typography>
      </div>
    </Paper>
  );
}

export default function AccountMovement(props) {
  const { t } = useTranslation(["forms"]);
  const { AutoOptions, accounts } = props;

  const classes = useStyles();

  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";

  const typePrint = [
    { id: 0, label: "افتراضي", key: "balance" },
    { id: 1, label: "مصادقة حـساب", key: "dept" },
    { id: 3, label: "WithItems", key: "dept" },
  ];
  const [rptParams, setRptParams] = React.useState({
    ...SAdefaultValues,
    dateFrom: from_date,
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    account: AutoOptions.Accindex[0],
    typePrint: typePrint[0],
  });

  const [dataExcel, setDataExcel] = useState([]);
  const [dataItems, setDataItems] = useState([]);
  const [dataTotals, setDataTotals] = useState({});
  const [invData, setInvData] = useState({});
  const [accountsName, setAccountsName] = useState({});
  const [fetching, setFetching] = useState(false);
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const datas = AutoOptions?.Datas ?? [];
  const [database, setDatabase] = useState(datas.find((obj) => obj.name == sto.db_name));
  const [infoData, setInfoData] = useState({ open: false, rest_id: 0, branch: 0 });
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };

  const viewHandle = async () => {
    setDataExcel([]);
    setDataItems([]);
    setDataTotals({});
    setFetching(true);
    if (rptParams.typePrint.id == 3) {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/rptAccBalanceItems?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
      } else {
        Urls = `AccountReports/rptAccBalanceItems?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          setDataItems(res.data.AccountBalance);
          // setDataItems(groupTransactions(res.data.AccountBalance));
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          setFetching(false);
          console.log(err);
          setDataTotals({});
          setDataItems([]);
          // toast.err("يوجد خطأ في الجلب");
        });

    }
    else if (rptParams.selectType.id == 1) {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/rptAccBalance?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
      } else {
        Urls = `AccountReports/rptAccBalance?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          setFetching(false);
          // console.log(err);
          setDataTotals({});
          setDataExcel([]);
          // toast.err("يوجد خطأ في الجلب");
        });
    }
    else {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/AccountsSumDataMulti?type=${rptParams.type?.id}
    &&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}
    &&acc_code=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account?.id}&&old=${rptParams?.oldBalance}
    &&open=${rptParams?.openBalance}`
      } else {
        Urls = `AccountReports/AccountsSumDataMulti?type=${rptParams.type?.id}
        &&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}
        &&acc_code=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account?.id}&&old=${rptParams?.oldBalance}
        &&open=${rptParams?.openBalance}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          // setData(res.data);
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          viewHandleOld();
        });
    }
  };
  const viewHandleOld = async () => {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `AccountReports/AccountsSumData?type=${rptParams.type?.id}
&&branch=${rptParams.branch.id}
&&center=${rptParams.center?.id}
&&dateFrom=${rptParams.dateFrom}
&&dateTo=${rptParams.dateTo}
&&acc_code=${rptParams.account?.id}`
    } else {
      Urls = `AccountReports/AccountsSumData?type=${rptParams.type?.id}
&&branch=${rptParams.branch.id}
&&center=${rptParams.center?.id}
&&dateFrom=${rptParams.dateFrom}
&&dateTo=${rptParams.dateTo}
&&acc_code=${rptParams.account?.id}&&db_name=${database?.name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        const dataItems = res.data.AccountBalance.map((row, i) => {
          return {
            ...row,
            no: i + 1,
            centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
          };
        });
        setDataExcel(dataItems);
        setDataTotals(res.data.totals);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        setDataTotals({});
        setDataExcel([]);
      });
  };
  const his = useHistory();
  const toBack = () => {
    his.push({ pathname: "/" });
  };
  const printHandle = () => {
    if (dataExcel.length == 0 && rptParams.typePrint.id != 3) return;
    if (dataItems.length == 0 && rptParams.typePrint.id === 3) return;
    const info = {
      data: rptParams.typePrint.id === 3 ? dataItems : dataExcel,
      tot: dataTotals,
      from: "الحساب",
      title: "حركة حساب خلال فترة",
      auto: {},
      account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      balance: parseFloat(dataTotals?.totBlncDept ?? 0)
        - parseFloat(dataTotals?.totBlncCredit ?? 0),
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: false,
      typePrint: rptParams.typePrint?.id,
      db_name: database?.name
    };
    if (rptParams.typePrint.id == 3) {
      setDataPrint(info);
      setInfoPrint(true);
    }
    else if (rptParams.typePrint.id == 1 && rptParams?.selectTypeSearch?.id == 1) {
      printHandleConfirm();
    } else {
      if (rptParams.selectType.id == 1) {
        setDataPrint(info);
        setInfoPrint(true);
      } else {
        printHandleSum();
      }
    }
  };
  const printHandleConfirm = () => {
    const info = {
      balance: parseFloat(dataTotals?.totBlncDept ?? 0)
        - parseFloat(dataTotals?.totBlncCredit ?? 0),
      from: "الحساب",
      title: "طلب مصادقة حـساب",
      auto: {},
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      date: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: true,
      db_name: database?.name
    };
    setDataPrint(info);
    setInfoPrint(true);
  };

  const printHandleSum = () => {
    const info = {
      data: dataExcel,
      tot: dataTotals,
      type: rptParams?.type?.id,
      kind_print: "2",
      title: "حركة حساب خلال فترة",
      title: "حركة حساب خلال فترة",
      account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
      fDate: rptParams?.dateFrom,
      tDate: rptParams?.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      db_name: database?.name

    };
    localStorage.setItem('iInfos', JSON.stringify(info));
    his.push({ pathname: "/CustBalance", state: info });
    window.location.reload(false);
  };
  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    if (propName === "db_name") {
      setDatabase(newValue);
    } else {
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  const [isOpenInv, setIsOpenInv] = useState(false);
  const [isOpenSandQ, setIsOpenSandQ] = useState(false);
  const [isOpenSandS, setIsOpenSandS] = useState(false);
  const [isOpenSandSD, setIsOpenSandSD] = useState(false);
  const [isOpenSandQD, setIsOpenSandQD] = useState(false);
  const [isOpenDailyRest, setIsOpenDailyRest] = useState(false);
  const [isOpenFirstRest, setIsOpenFirstRest] = useState(false);
  const [isOpenMultiSarf, setIsOpenMultiSarf] = useState(false);
  const [isOpenMultiQbd, setIsOpenMultiQbd] = useState(false);



  const [allow, setAllow] = useState({ inv: false, sqbd: false, sandQD: false, ssrf: false, sandSD: false, dailyRes: false, FirstRest: false, multiSarf: false, multiQbd: false });
  const handleOpenInvData = () => {
    setAllow({ ...allow, inv: !isOpenInv });
    setIsOpenInv(!isOpenInv);
  }; // E rsa

  const handleOpenSandQData = () => {
    setAllow({ ...allow, sqbd: !isOpenSandQ });
    setIsOpenSandQ(!isOpenSandQ);
  }; // E rsa
  const handleOpenSandSData = () => {
    setAllow({ ...allow, ssrf: !isOpenSandS });
    setIsOpenSandS(!isOpenSandS);
  }; // E rsa
  const handleOpenSandSDData = () => {
    setAllow({ ...allow, sandSD: !isOpenSandSD });
    setIsOpenSandSD(!isOpenSandSD);
  }; // E rsa
  const handleOpenSandQDData = () => {
    setAllow({ ...allow, sandQD: !isOpenSandQD });
    setIsOpenSandQD(!isOpenSandQD);
  }; // E rsa
  const handleOpenDailyRest = () => {
    setAllow({ ...allow, dailyRes: !isOpenDailyRest });
    setIsOpenDailyRest(!isOpenDailyRest);
  }; // E rsa
  const handleOpenFirstRest = () => {
    setAllow({ ...allow, FirstRest: !isOpenFirstRest });
    setIsOpenFirstRest(!isOpenFirstRest);
  }; // E rsa
  const handleOpenMultiSarf = () => {
    setAllow({ ...allow, multiSarf: !isOpenMultiSarf });
    setIsOpenMultiSarf(!isOpenMultiSarf);
  }; // E rsa

  const handleOpenMultiQbd = () => {
    setAllow({ ...allow, multiQbd: !isOpenMultiQbd });
    setIsOpenMultiQbd(!isOpenMultiQbd);
  };

  const Export_excel = () => {
    if (rptParams.selectType.id == 1) {
      exportExcelReport({
        title: "كشف حساب" + "  " + "من تاريخ" + "  :" + rptParams.dateFrom + "  " + "إلى تاريخ" + "   :" + rptParams.dateTo,
        // companyName: "شركة OraxCloud",
        // fromDate: rptParams.dateFrom,
        // toDate: rptParams.dateTo,
        info: [
          {
            label: "من تاريخ",
            value: rptParams.dateFrom
          },
          {
            label: "إلى تاريخ",
            value: rptParams.dateTo
          },
          {
            label: "اسم الحساب",
            value: rptParams.account?.name ?? ""
          },
          {
            label: "رقم الحساب",
            value: rptParams.account.id
          },
          {
            label: "الفرع",
            value: rptParams.branch.name
          },
        ],

        columns: [
          {
            title: "م",
            field: "__index",
            width: 7
          },
          {
            title: "البيان",
            field: "notes",
            width: 40
          },
          {
            title: "رقم المرجع",
            field: "ref_no",
            // width: 18
          },
          {
            title: "نوع المستند",
            field: "type",
            // width: 15
          },
          {
            title: "مركز التكلفة",
            field: "centerName",
            // width: 15
          },
          {
            title: "التاريخ",
            field: "date",
            // width: 15,
            type: "date"
          },
          {
            title: "رقم المستند",
            field: "doc_no",
            // width: 12
          },
          {
            title: "مدين",
            field: "dept",
            // width: 18,
            type: "number"
          },
          {
            title: "دائن",
            field: "credit",
            // width: 18,
            type: "number"
          },
          {
            title: "الرصيد",
            field: "balance",
            // width: 18,
            type: "number"
          }
        ],

        data: dataExcel,

        totals: [
          {
            label: "إجمالي المدين",
            field: "debt"
          },
          {
            label: "إجمالي الدائن",
            field: "credit"
          }
        ],

        fileName: "كشف_حساب",

        sheetName: "كشف الحساب",

        showSerial: false,

        showFilter: true,

        freezeHeader: true,

        rightToLeft: true
      });
    } else {
      exportExcelReport({
        title: "كشف حساب" + "  " + "من تاريخ" + "  :" + rptParams.dateFrom + "  " + "إلى تاريخ" + "   :" + rptParams.dateTo,
        // companyName: "شركة OraxCloud",
        // fromDate: rptParams.dateFrom,
        // toDate: rptParams.dateTo,
        info: [
          {
            label: "من تاريخ",
            value: rptParams.dateFrom
          },
          {
            label: "إلى تاريخ",
            value: rptParams.dateTo
          },
          // {
          //   label: "اسم الحساب",
          //   value: rptParams.account?.name??""
          // },
          // {
          //   label: "رقم الحساب",
          //   value:  rptParams.account.id
          // },
          {
            label: "الفرع",
            value: rptParams.branch.name
          },
        ],
        columns: [
          {
            title: "م",
            field: "__index",
            width: 7
          },
          {
            title: "رقم الحساب",
            field: "Code",
            width: 15
          },
          {
            title: "الحساب",
            field: "aname",
            width: 18
          },
          {
            title: "مدين (افتتاحي)",
            field: "open_dept",
            width: 18
          },
          {
            title: "دائن (افتتاحي)",
            field: "open_credit",
            width: 18,
            type: "number"
          },
          {
            title: "مدين (سابق)",
            field: "OBX_Dept",
            width: 18,
            type: "number"
          },
          {
            title: "دائن (سابق)",
            field: "OBX_Credit",
            width: 15,
            type: "number"
          },
          {
            title: "مدين (حركة)",
            field: "dept",
            width: 15,
            type: "number"
          },
          {
            title: "دائن (حركة)",
            field: "credit",
            width: 18,
            type: "number"
          },
          {
            title: "مدين (رصيد)",
            field: "end_Dept",
            width: 18,
            type: "number"
          },
          {
            title: "دائن (رصيد)",
            field: "end_Credit",
            width: 18,
            type: "number"
          }
        ],

        data: dataExcel,

        totals: [
          {
            label: "إجمالي المدين",
            field: "end_Dept"
          },
          {
            label: "إجمالي الدائن",
            field: "end_Credit"
          }
        ],

        fileName: "كشف_حساب",

        sheetName: "كشف الحساب",

        showSerial: false,

        showFilter: true,

        freezeHeader: true,

        rightToLeft: true
      });
    }

  };

  const [fromDate, setFromDate] = useState("2026-01-01");
  const [toDate, setToDate] = useState("2026-10-22");
  const [branch, setBranch] = useState("all");
  const [costCenter, setCostCenter] = useState("all");
  const [currency, setCurrency] = useState("all");
  const [documentType, setDocumentType] = useState("all");
  const [sortBy, setSortBy] = useState("date");
  const [printType, setPrintType] = useState("default");
  const [includePrevious, setIncludePrevious] = useState(true);
  const [openingBalance, setOpeningBalance] = useState(true);
  const [searchText, setSearchText] = useState(1210001);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const rows = dataExcel;

  const filteredRows = useMemo(() => {
    let result = dataExcel.filter((row) => {
      const dateOk = (!rptParams.dateFrom || row.date >= rptParams.dateFrom) &&
        (!rptParams.dateTo || row.date <= rptParams.dateTo);
      // const typeOk = documentType === "all" || docTypes[row?.type]?.name === documentType;

      // String(row.notes || "").toLowerCase().includes(searchText.toLowerCase());
      return dateOk;
    });
    result = [...result].sort((a, b) => sortBy === "date"
      ? a.date.localeCompare(b.date) || a.id - b.id
      : Number(a.docNo) - Number(b.docNo));
    return result;
  }, [dataExcel, rptParams, documentType, searchText, sortBy]);

  const totalDebit = filteredRows.reduce((sum, row) => sum + Number(row.debit || 0), 0);
  const totalCredit = filteredRows.reduce((sum, row) => sum + Number(row.credit || 0), 0);
  const netMovement = totalDebit - totalCredit;
  const currentBalance = filteredRows.length ? Number(filteredRows[filteredRows.length - 1].balance || 0) : 0;

  const handleSearch = () => {
    setPage(0);
    // if (onSearch) onSearch({ fromDate, toDate, branch, costCenter, currency, documentType, sortBy, accountCode: searchText, includePrevious, openingBalance });
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className="am-brand">
            <span className="am-brand-mark"><MenuBookOutlinedIcon /></span>
            <div>
              <Typography className={classes.title}>حركة حساب خلال فترة</Typography>
              <Typography className="am-subtitle">التقارير المالية <span>›</span> كشف حركة الحساب</Typography>
            </div>
          </div>
          <div className="am-header-actions">
            <Tooltip title="الرئيسية"><IconButton className="am-home-btn"><HomeOutlinedIcon /></IconButton></Tooltip>
            <Chip label="التقارير المالية" className="am-header-chip" />
          </div>
        </Toolbar>
      </AppBar>

      <main className="am-page" >
        <Paper elevation={0} className={classes.filters} style={{ direction: "rtl" }}>
          <div className="am-section-heading">
            <div><span className="am-heading-icon"><FilterListOutlinedIcon /></span><div><Typography className="am-section-title">تصفية حركة الحساب</Typography><Typography className="am-section-hint">حدد الفترة والحساب ثم اعرض النتائج</Typography></div></div>
            <Chip label="تقرير تفصيلي" className="am-report-chip" />
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
              <TextField fullWidth size="small"
                variant="outlined" label="من تاريخ" type="date"
                value={rptParams.dateFrom}
                onChange={(e) => onChangeData("dateFrom")}
                className={classes.field}
                InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField fullWidth size="small" variant="outlined"
                label="إلى تاريخ" type="date" value={rptParams.dateTo}
                onChange={(e) => onChangeData("dateTo")}
                className={classes.field}
                InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="مركز التكلفة" value={rptParams.center}
                onChange={(event, newValue) => {
                  onChangeAutoData("center", newValue);
                }}
                options={AutoOptions.center} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="الفرع" value={rptParams.branch}
                onChange={(event, newValue) => {
                  onChangeAutoData("branch", newValue);
                }}
                options={AutoOptions.Branches} />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              {/* <TextField fullWidth size="small" variant="outlined" label="رقم الحساب" 
              value={searchText} onChange={(e) => setSearchText(e.target.value)} className={classes.field} 
              InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" />
              </InputAdornment> }} /> */}
              <AccountSelect
                accounts={AutoOptions.Accindex}
                account={rptParams.account}
                onSelect={(newValue) => {
                  onChangeAutoData("account", newValue);
                }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={2}>
              <TextField fullWidth size="small" variant="outlined" label="الحساب المحدد" value={`${accountCode} - ${accountName}`} className={classes.field} InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start"><AccountBalanceOutlinedIcon fontSize="small" /></InputAdornment> }} />
            </Grid> */}
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="نوع المستند"
                value={rptParams.docType}
                onChange={(event, newValue) => {
                  onChangeAutoData("docType", newValue);
                }}
                options={docTypes} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="العملة" value={rptParams.omla}
                onChange={(event, newValue) => {
                  onChangeAutoData("omla", newValue);
                }}
                options={AutoOptions?.Omlat} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="نوع الطباعة"
                value={printType} onChange={(e) => setPrintType(e.target.value)}
                options={[{ value: "default", label: "الافتراضي" }, { value: "detailed", label: "تفصيلي" }]} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <SelectField label="ترتيب حسب" value={sortBy} onChange={(e) => setSortBy(e.target.value)} options={[{ value: "date", label: "التاريخ" }, { value: "docNo", label: "رقم المستند" }]} />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className="am-filter-bottom">
              <FormControlLabel control={<Checkbox color="primary" checked={includePrevious} onChange={(e) => setIncludePrevious(e.target.checked)} />} label="إظهار الرصيد السابق" />
              <FormControlLabel control={<Checkbox color="primary" checked={openingBalance} onChange={(e) => setOpeningBalance(e.target.checked)} />} label="إظهار الرصيد الافتتاحي" />
            </Grid>
            <Grid item xs={12} md={8} lg={2} className="am-filter-actions">
              <Button variant="outlined" className={`${classes.button} am-total-button`} startIcon={<BarChartOutlined />} onClick={() => { handleSearch("total"); }}>إجمالي</Button>
              <Button variant="contained" className={`${classes.button} ${classes.primary}`} startIcon={<ViewListOutlined />} onClick={() => { handleSearch("detailed"); }}>تفصيلي</Button>
            </Grid>
          </Grid>
        </Paper>

        <div className="am-toolbar" dir="ltr">
          <div className="am-results-label"><span className="am-live-dot" /> نتائج التقرير <b>{filteredRows.length}</b> حركة</div>
          <div className="am-toolbar-buttons">
            <Button className={`${classes.button} am-action-btn`} startIcon={<VisibilityOutlinedIcon />} onClick={() => viewHandle()}>عرض النتيجة</Button>
            <Button className={`${classes.button} am-action-btn`} startIcon={<PrintOutlinedIcon />} onClick={() => printHandle()}>طباعة</Button>
            <Button className={`${classes.button} am-action-btn`} startIcon={<GetAppOutlinedIcon />} onClick={() => Export_excel()}>{t("excel_export")}</Button>
            <Button className={`${classes.button} am-exit-btn`} startIcon={<ExitToAppOutlinedIcon />} onClick={toBack}>{t("exit")}</Button>
          </div>
        </div>

        <Grid container spacing={2} className="am-summary-grid">
          <Grid item xs={12} sm={6} lg={3}><SummaryCard title="إجمالي المدين" value={money(totalDebit)} tone="blue" icon={<MonetizationOnOutlinedIcon />} /></Grid>
          <Grid item xs={12} sm={6} lg={3}><SummaryCard title="إجمالي الدائن" value={money(totalCredit)} tone="green" icon={<AccountBalanceOutlinedIcon />} /></Grid>
          <Grid item xs={12} sm={6} lg={3}><SummaryCard title="صافي الحركة" value={money(netMovement)} tone={netMovement < 0 ? "red" : "purple"} icon={<TrendingUpOutlinedIcon />} /></Grid>
          <Grid item xs={12} sm={6} lg={3}><SummaryCard title="الرصيد الحالي" value={money(currentBalance)} tone="slate" icon={<ReceiptLongOutlinedIcon />} /></Grid>
        </Grid>

        <Paper elevation={0} className={`${classes.tablePaper} am-table-paper`}>
          <div className="am-table-heading">
            <div className="am-table-title"><span className="am-heading-icon"><ReceiptLongOutlinedIcon /></span><div><Typography>تفاصيل حركة الحساب</Typography><small>الحساب: {rptParams.account.id} — {rptParams.account?.name}</small></div></div>
            <div className="am-table-tools"><Chip label={`${filteredRows.length} سجل`} size="small" className="am-count-chip" /><Button size="small" className="am-table-filter" startIcon={<FilterListOutlinedIcon />}>خيارات العرض</Button></div>
          </div>
          <AccountMovementTable
            {...{
              data: dataExcel ? dataExcel : [], setInvData, handleOpenInvData, handleOpenSandQData, handleOpenSandSData
              , handleOpenSandSDData, handleOpenSandQDData, handleOpenDailyRest, handleOpenFirstRest,
              handleOpenMultiSarf, handleOpenMultiQbd, infoData, setInfoData, AutoOptions, db_name: database?.name,
              classes, filteredRows, money, page, rowsPerPage, fetching
            }}
          />
          <Divider />
          <div className="am-table-footer">
            <Typography className="am-footer-note">إجمالي السجلات: <b>{filteredRows.length}</b> — المدين: <b>{money(totalDebit)}</b> — الدائن: <b>{money(totalCredit)}</b></Typography>
            <TablePagination component="div" count={filteredRows.length} page={page} onChangePage={(e, p) => setPage(p)} rowsPerPage={rowsPerPage} onChangeRowsPerPage={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} rowsPerPageOptions={[10, 15, 25, 50]} labelRowsPerPage="عرض" labelDisplayedRows={({ from, to, count }) => `${from}-${to} من ${count}`} />
          </div>
        </Paper>
        <div className="am-page-footer">OraxCloud · التقارير المالية <span>•</span> حركة حساب خلال فترة</div>
      </main>
    </div>
  );
}
